import { toast } from 'react-toastify';
import { PrizeDataToFormData } from 'entities/prize/lib';
import { prizesApi } from './prizesApi';

const createPrizeApi = prizesApi.injectEndpoints({
  endpoints: (builder) => ({
    createPrize: builder.mutation({
      query: ({ data }) => {
        const formData = PrizeDataToFormData(data);
        return {
          url: '/shop/admin/v1/prize-type/prize-types',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно добавили приз', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'Prizes' }];
      },
    }),
    updatePrizeId: builder.mutation({
      query: ({ data, id }) => {
        const formData = PrizeDataToFormData(data);
        return {
          url: `/shop/admin/v1/prize-type/prize-types/${id}`,
          method: 'PATCH',
          body: formData,
        };
      },
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно обновили приз', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'PrizeId' }];
      },
    }),
  }),
});

export const { useCreatePrizeMutation, useUpdatePrizeIdMutation } = createPrizeApi;
